import { FormEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Box, Button, Paper } from "@mui/material";
import IContact, { DEFAULT_CONTACT } from "../../../models/contact";
import ContactFormFields from "../../../components/input/form/contact/ContactFormFields";
import { useTranslation } from "react-i18next";
import { EntryWrapper, FormWrapper } from "../../../components/customStyles/form";
import propertyGroupService from "../../../services/propertyGroupService/PropertyGroupService";
import { IPropertyGroup } from "../../../models/propertyGroup";
import contactService from "../../../services/contact/ContactService";
import { validEmailRegex, validPhoneRegex } from "../../../utils/regex";
import EditOnly from "../../../components/permissions/EditOnly";

const ContactAddPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isErrorMessageVisible, setIsErrorMessageVisible] = useState<boolean>(false);
  const [propertyGroups, setPropertyGroups] = useState<IPropertyGroup[]>([]);
  const [contact, setContact] = useState<IContact>(DEFAULT_CONTACT);

  useEffect(() => {
    propertyGroupService.GetPropertyGroups().then(setPropertyGroups);
  }, []);

  const onCreateContact = async (event: FormEvent) => {
    event.preventDefault();

    try {
      const id = await contactService.CreatePunchContact(contact);
      if (!id) return setIsErrorMessageVisible(true);

      setIsErrorMessageVisible(false);
      navigate("..");
    } catch (error) {
      setIsErrorMessageVisible(true);
    }
  };

  const isValidForm = () => {
    if (
      !contact.name ||
      !contact.positionFrench ||
      contact.propertyGroupIds.length <= 0 ||
      (contact.email && !validEmailRegex.test(contact.email)) ||
      (contact.phone && !validPhoneRegex.test(contact.phone))
    ) return false;

    return true;
  };

  return (
    <Box component={Paper} sx={{ width: "100%" }}>
      <form autoComplete="off" onSubmit={onCreateContact}>
        <FormWrapper>
          {isErrorMessageVisible && (
            <Alert
              severity="error"
              sx={{ marginBottom: "1em" }}
            >
              {t("table.contact.addErrorMessage")}
            </Alert>
          )}

          <ContactFormFields
            contact={contact}
            setContact={setContact}
            propertyGroups={propertyGroups}
          />

          <EntryWrapper sx={{ justifyContent: "flex-end" }}>
            <EditOnly>
              <Button
                type="submit"
                variant="contained"
                color="secondary"
                disabled={!isValidForm()}
                sx={{
                  margin: "1em",
                  marginLeft: "0",
                }}
              >
                {t("table.contact.create")}
              </Button>
            </EditOnly>
          </EntryWrapper>
        </FormWrapper>
      </form>
    </Box>
  );
};

export default ContactAddPage;
